import { observable, action, computed, createTransformer, reaction, extendObservable } from "mobx";
import MOTService from "../../../services/MOTService";
import { getMensagemDeErro } from "../../../utils/functions";

export default class HistoricoContratacaoStore {

    @observable filtros;
    @observable momentDataInicioFiltro;
    @observable momentDataFimFiltro;
    @observable dataInicioFiltroValidacao;
    @observable loading;
    @observable loadingEmpresasGlobo;
    @observable carregando;
    @observable cpf;
    @observable cpfSelecionado;

    @observable dadosMot;
    @observable dadosContrato;
    @observable dadosValidacao;

    @observable simulaQuarentena;
    @observable cpfApto;

    constructor(props) {
        this.loading = false;
        this.loadingEmpresasGlobo = false;
        this.cpf = null;
        this.cpfSelecionado = null;

        this.simulaQuarentena = false;

        this.MOTService = new MOTService();
        this.dadosMot = [];
        this.dadosContrato = [];

        this.resetFiltros();

        this.simulaQuarentena = false;
        this.carregando = false;
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.dadosValidacao = [];

        const loadingPromises = Promise.all([
            this.MOTService.findHistoricoContratacao(filtro).then(response => {
                let cpfApto = false;
                let id = 1;

                if (response.data) {

                    const pessoa = _.get(response.data, "pessoa");

                    // preenche os dados da pessoa
                    if (pessoa) {
                        this.dadosMot = [];
                        this.dadosMot =
                            [{
                                "cpf": _.get(pessoa, "cpf"),
                                "nome": _.get(pessoa, "nome"),
                                "email": _.get(pessoa, "email"),
                                "dataNascimento": _.get(pessoa, "dataNascimento")
                            }];
                    }

                    const contratos = _.get(response.data, "contratos");
                    if (contratos && contratos.length > 0) {
                        this.simulaQuarentena = true;
                        this.dadosContrato = contratos
                            .filter(cont => cont) // Garante que não há itens nulos no array
                            .map(cont => {
                                const sistema = _.get(cont, "sistemaOrigem") === 'FPW' ? 'GLOBO' : _.get(cont, "sistemaOrigem");
                                return {
                                    matricula: sistema === 'SGTMOT' ? _.get(cont, "solicitacao") : _.get(cont, "matricula"),
                                    sistemaOrigem: sistema,
                                    dataInicio: _.get(cont, "dataInicio"),
                                    dataTermino: sistema === 'SGTMOT' ? _.get(cont, "dataTermino") : _.get(cont, "dataFim"),
                                    cargo: `${_.get(cont, "nomeCargo")}(${_.get(cont, "codigoCargo")})`,
                                    gestor: _.get(cont, "nomeGestorArea"),
                                };
                            }).sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio));
                    } else {
                        cpfApto = true;
                    }

                    const validacaoCPF = _.get(response.data, "validacaoCPF");
                    if (validacaoCPF) {
                        this.dadosValidacao = [];
                        const obstrucaoCPF = _.get(validacaoCPF, "obstrucaoValidacaoCPF");
                        const alertaCPF = _.get(validacaoCPF, "alertaValidacaoCPF");

                        for (let mensagem of alertaCPF) {
                            if (mensagem) {

                                const validacao = {
                                    "id": id,
                                    "tipoValidacao": "alerta",
                                    "mensagemValidacao": mensagem
                                }
                                this.dadosValidacao.push(validacao);
                                id++;
                            }
                        }

                        if (obstrucaoCPF.length > 0) {

                            for (let mensagem of obstrucaoCPF) {
                                if (mensagem) {

                                    const validacao = {
                                        "id": id,
                                        "tipoValidacao": "obstrucao",
                                        "mensagemValidacao": mensagem
                                    }
                                    this.dadosValidacao.push(validacao);
                                    id++;
                                }
                            }

                        } else {
                            cpfApto = true;
                        }
                    }

                } else {
                    cpfApto = true;
                }
                if (cpfApto) {
                    const apto = {
                        "id": id,
                        "tipoValidacao": "apto",
                        "mensagemValidacao": "CPF Apto para contrato SGTMOT."
                    }
                    this.dadosValidacao.push(apto);
                }

            }).catch(error => {
                this.erro = getMensagemDeErro(error);
                this.carregando = false;
            })
        ]);

        loadingPromises.then(
            () => {
                this.loading = false;
                this.carregando = false;
            }
        ).catch(
            (error) => this.loading = false
        );
    }

    resetFiltros = () => {
        this.filtros = {
            cpf: null,
            cpfSelecionado: null
        };
        this.simulaQuarentena = false;

    };

    carregarTabela = () => {
        this.loading = true;
    };

    @action
    displayButton(row) {
        if(row) {
            let form = Object.assign({}, row);
            //Pendente = 1
            //TODO: realizar a busca por enumerados
            if(form.sistemaOrigem === "SGTMOT")
                return "";
            else
                return "none";
        }
    }

}